import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getTelegramWebApp } from '@app/shared/utils/common';
import { Page } from '@app/routes';

export const useSetWindowPrefs = () => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = '';
    document.title = t('app.title');
  }, [i18n.language, t, pathname]);

  useEffect(() => {
    const tg = getTelegramWebApp();
    if (tg) {
      if (!tg.isVersionAtLeast('6.1')) {
        return;
      }

      tg.setBackgroundColor('#040A19');
      tg.setHeaderColor('#040A19');

      if (
        pathname === '/' ||
        (pathname as Page) === Page.AUTH ||
        (pathname as Page) === Page.USER_DATA_FORM
      ) {
        tg.BackButton.hide();
      } else {
        tg.BackButton.show();
        tg.BackButton.onClick(() => navigate(-1));
      }
    }
  }, []);
};
